module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/brooklinen-0d4d26782d7f2cdc16d58b9e8bcc1cc1.png";